import { DrawerComponent } from '~/shared/ui/Drawer'
import { Content } from './Content'

type WithdrawalDrawerProps = {
  isShow: boolean
  onClose: () => void
}

export function WithdrawalDrawer({ isShow, onClose }: WithdrawalDrawerProps) {
  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      <Content />
    </DrawerComponent>
  )
}
